import React from "react";
import { useTranslation } from "../i18n/I18nProvider";

export type CoverageType = "COMPREHENSIVE" | "SPECIFIC" | "DECIDE" | "KNOW" | "MEDICARE";

interface CoverageTypeStepProps { }

const COVERAGE_OPTIONS: Array<{
    type: CoverageType;
    iconPath: string;
    translationKey: "comprehensive" | "specific" | "decide" | "know" | "medicare";
}> = [
        {
            type: "COMPREHENSIVE",
            iconPath: "/media/icons/shield.svg",
            translationKey: "comprehensive",
        },
        {
            type: "SPECIFIC",
            iconPath: "/media/icons/heart.svg",
            translationKey: "specific",
        },
        {
            type: "DECIDE",
            iconPath: "/media/icons/question.svg",
            translationKey: "decide",
        },
        {
            type: "KNOW",
            iconPath: "/media/icons/document.svg",
            translationKey: "know",
        },
        {
            type: "MEDICARE",
            iconPath: "/media/icons/people.svg",
            translationKey: "medicare",
        },
    ];

export const CoverageTypeStep: React.FC<CoverageTypeStepProps> = () => {
    const { t } = useTranslation();

    const handleScroll = () => {
        const wizardProgress = document.querySelector(".wizard-progress");
        if (wizardProgress) {
            wizardProgress.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <div className="coverage-type-section">
            <h2 className="coverage-type-title">{t("wizard.coverageType.title")}</h2>
            <p className="coverage-type-helper">{t("wizard.coverageType.helper")}</p>

            <div className="coverage-type-grid">
                {COVERAGE_OPTIONS.map(({ type, translationKey }) => (
                    <div
                        key={type}
                        className="coverage-type-option"
                        onClick={handleScroll}
                    >
                        <div className="coverage-type-icon-box">
                            {type === "COMPREHENSIVE" && <span>🛡️</span>}
                            {type === "SPECIFIC" && <span>♡</span>}
                            {type === "DECIDE" && <span>?</span>}
                            {type === "KNOW" && <span>📄</span>}
                            {type === "MEDICARE" && <span>👥</span>}
                        </div>
                        <div className="coverage-type-text">
                            <span className="coverage-type-label">
                                {t(`wizard.coverageType.options.${translationKey}.title`)}
                            </span>
                            <span className="coverage-type-sublabel">
                                {t(`wizard.coverageType.options.${translationKey}.desc`)}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
